import { render, staticRenderFns } from "./ReviewData.vue?vue&type=template&id=55749808&"
import script from "./ReviewData.vue?vue&type=script&lang=js&"
export * from "./ReviewData.vue?vue&type=script&lang=js&"
import style0 from "./ReviewData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports